export default __webpack_public_path__ + "static/media/wedding-couple.c0e59df1.webp";